export const payModalCheckbox = [
    { id: 1, name: 'Правила пользования' },
    { id: 2, name: 'Политика обработки персональный данных' },
    { id: 3, name: 'Согласие на обработку персональных данных' },
    { id: 4, name: 'Согласие на получение персональной рассылки' },
    { id: 5, name: 'Согласие на подписку' },
    { id: 6, name: 'Агентский договор (публичная оферта)' },
];
